<template>
  <div class="row mx-0">
    <div
      class="mb-3 p-4 bg-secondary-1 rounded col-md-4 col-sm-12 d-flex align-items-end flex-column flex-md-row"
    >
      <custom-drop-down
        v-model="selectedAcademicYear"
        :clearable="false"
        fieldkey="id"
        fieldname="name"
        :options="academicYears"        
        placeholder="Seleccione Año Académico"
        class="flex-grow-1 w-100"
        @input="$emit('on-change-academic-year', selectedAcademicYear)"
      />     
    </div>
  </div>
</template>

<script>
import CustomDropDown from "custom-drop-down";

export default {
  name: "ProgressFilter",
  components: {
    CustomDropDown    
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    academicYears: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedAcademicYear: this.defaultValue,
    }
  },
  computed: {
    lastAcademicYear() {
      if (!this.academicYears?.length) {
        return null;
      }

      return this.academicYears.reduce((max, academicYear) =>
        max.id > academicYear.id ? max : academicYear
      );
    },
    isLastAcademicYearSelected() {
      if (!this.academicYears?.length) {
        return false;
      }

      return this.lastAcademicYear?.id == this.selectedAcademicYear?.id;
    },
  },
  watch: {
     defaultValue (newValue) {
       this.selectedAcademicYear = newValue
     }
  } 
};
</script>
